<template>
  <div class="modal fade create-new-user-modal update-modal" id="UpdateCameraModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Atualizar câmera</h1>
                  <button type="button" class="btn-close create-new-user-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formUpdateCamera" v-on:submit="updateCameraMethod()">
                <div class="modal-body ps-30 pe-30">
                  <p v-if="getCurrentCamera">Preencha as informações abaixo para atualizar a câmera <strong>"{{ getCurrentCamera.name }}"</strong></p>

                  <div
                    v-if="getCurrentCamera"
                    class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30"
                  >
                    <label for="update_active_option" class="form-label fw-medium">Câmera está ativa:</label>
                    <select id="update_active_option" class="form-select shadow-none text-black fs-md-15"
                    >
                      <option :selected="getCurrentCamera.active" value="1" class="fw-medium">Sim</option>
                      <option :selected="!getCurrentCamera.active" value="0" class="fw-medium">Não</option>
                    </select>
                  </div>

                  <div
                    class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30"
                  >
                    <label for="update_record_option" class="form-label fw-medium">Armazenar gravação:</label>
                    <select v-model="record" id="update_record_option" class="form-select shadow-none text-black fs-md-15"
                    >
                      <option 
                        v-for="(value, key) in options_record_cam" 
                        :key="key"
                        :selected="record == value.value" 
                        :value="value.value" 
                        class="fw-medium"
                      >
                        {{ value.text }}
                      </option>
                    </select>
                  </div>

                  <div
                    v-if="record == 1"
                    class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30"
                  >
                    <label for="storage_duration" class="form-label fw-medium">Tempo de armazenamento:</label>
                    <select v-model="storage_duration" id="storage_duration" ref="storage_duration" class="form-select shadow-none text-black fs-md-15"
                    >
                      <option v-for="(value, key) in options_storage_duration" :selected="value.value == storage_duration" :value="value.value" :key="key" class="fw-medium">{{ value.text }}</option>
                    </select>
                  </div>

                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                    <button type="button" class="btn btn-success fw-bold" style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;" @click="openPricesModal">
                      <i class="flaticon-search-interface-symbol me-2"></i> Ver tabela de preços
                    </button>
                  </div>

                  <div>
                    <div class="form-check mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                      <input
                        v-model="ai_monitoring_enabled"
                        class="form-check-input"
                        type="checkbox"
                        id="update_ai_monitoring_enabled"
                      />
                      <label class="form-check-label fw-medium" for="update_ai_monitoring_enabled">
                        Ativar monitoramento de pessoas/alarme IA
                      </label>
                    </div>

                    <div class="form-check mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                      <input
                        v-model="external_transmission_active"
                        class="form-check-input"
                        type="checkbox"
                        id="update_external_transmission_active"
                      />
                      <label class="form-check-label fw-medium" for="update_external_transmission_active">
                        Ativar transmissão externa (SmartSampa)
                      </label>
                    </div>

                    <h5 class="mb-20 fs-16 mt-4">Informe o endereço da camera:</h5>
                    <div class="row">
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl col-xxl-6">
                        <label class="text-black fw-semibold mb-10 fs-16" for="cepUpdate">CEP</label>
                        <input
                          class="form-control shadow-none rounded-0 text-black radius-7 custom-font-size"
                          type="text"
                          id="cepUpdate"
                          ref="cepFieldUpdate"
                          v-model="form.cep"
                          @input="handleCepInput"
                          maxlength="9"
                          placeholder="Digite o CEP"
                          required
                        />
                        <label ref="cepFieldAlertUpdate" class="text-red mb-10 ms-1 d-none-custom fs-16" style="display: none;">O cep é um campo obrigatório</label>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl col-xxl-6">
                        <label class="text-black fw-semibold mb-10 fs-16" for="streetUpdate">Rua:</label>
                        <input
                          class="form-control shadow-none rounded-0 text-black radius-7 custom-font-size"
                          type="text"
                          id="streetUpdate"
                          ref="streetFieldUpdate"
                          v-model="form.street"
                          placeholder="Rua"
                          disabled="true"
                        />
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl col-xxl-6 mt-4">
                        <label class="text-black fw-semibold mb-10 fs-16" for="neighborhoodUpdate">Bairro:</label>
                        <input
                          class="form-control shadow-none rounded-0 text-black radius-7 custom-font-size"
                          type="text"
                          id="neighborhoodUpdate"
                          ref="neighborhoodFieldUpdate"
                          v-model="form.neighborhood"
                          placeholder="Bairro"
                          disabled="true"
                        />
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl col-xxl-6 mt-4">
                        <label class="text-black fw-semibold mb-10 fs-16" for="cityUpdate">Cidade:</label>
                        <input
                          class="form-control shadow-none rounded-0 text-black radius-7 custom-font-size"
                          type="text"
                          id="cityUpdate"
                          ref="cityFieldUpdate"
                          v-model="form.city"
                          placeholder="Cidade"
                          disabled="true"
                        />
                        <label ref="cityFieldAlertUpdate" class="text-red mb-10 ms-1 d-none-custom fs-16" style="display: none;">A cidade é um campo obrigatório</label>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl col-xxl-6 mt-4">
                        <label class="text-black fw-semibold mb-10 fs-16" for="stateUpdate">Estado:</label>
                        <input
                          class="form-control shadow-none rounded-0 text-black radius-7 custom-font-size"
                          type="text"
                          id="stateUpdate"
                          ref="stateFieldUpdate"
                          v-model="form.state"
                          placeholder="Estado"
                          disabled="true"
                        />
                        <label ref="stateFieldAlertUpdate" class="text-red mb-10 ms-1 d-none-custom fs-16" style="display: none;">O estado é um campo obrigatório</label>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl col-xxl-6 mt-4 mb-4">
                        <label class="text-black fw-semibold mb-10 fs-16" for="numberUpdate">Número:</label>
                        <input
                          class="form-control shadow-none rounded-0 text-black radius-7 custom-font-size"
                          type="text"
                          id="numberUpdate"
                          ref="numberFieldUpdate"
                          v-model="form.number"
                          placeholder="Número"
                          required
                        />
                        <label ref="numberFieldAlertUpdate" class="text-red mb-10 ms-1 d-none-custom fs-16" style="display: none;">O número é um campo obrigatório</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div id="alertResponseApiUpdateCamera" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageUpdateCamera">
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                
                <div class="modal-footer">
                  <button type="submit" ref="buttonUpdateUser" class="btn btn-success">Atualizar câmera</button>
                  <button type="button" class="btn btn-danger create-new-user-modal" data-bs-dismiss="modal" @click="setCurrentCamera(null)">Cancelar</button>
                </div>
              </form>
          </div>
      </div>
  </div>
  <PricesModal />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import api from '../../config/axios.js';
import PricesModal from '../Prices/PricesModal.vue';
import * as bootstrap from 'bootstrap';

export default {
  name: "UpdateCameraModal",
  components: {
    PricesModal
  },
  data () {
    return {
      record: false,
      storage_duration: 0,
      ai_monitoring_enabled: false,
      external_transmission_active: false,
      form: {
        cep: "",
        street: "",
        neighborhood: "",
        number: "",
        city: "",
        state: ""
      },
      options_storage_duration: [
        {
          "value": "1",
          "text": "1 Dia"
        },
        {
          "value": "3",
          "text": "3 Dias"
        },
        {
          "value": "5",
          "text": "5 Dias"
        },
        {
          "value": "7",
          "text": "7 Dias"
        },
        {
          "value": "10",
          "text": "10 Dias"
        },
        {
          "value": "20",
          "text": "20 Dias"
        },
        {
          "value": "30",
          "text": "30 Dias"
        },
        {
          "value": "60",
          "text": "60 Dias"
        },
        {
          "value": "90",
          "text": "90 Dias"
        },
        {
          "value": "120",
          "text": "120 Dias"
        },
      ],
      options_record_cam: [
        {
          "value": "1",
          "text": "Sim"
        },
        {
          "value": "0",
          "text": "Não"
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentCamera'
    ])
  },
  watch: {
    getCurrentCamera: {
      handler(newValue) {
        if(newValue != null){
          this.record = newValue.record;
          this.storage_duration = newValue.storage_duration;
          this.ai_monitoring_enabled = newValue.ai_monitoring_enabled === true || Number(newValue.ai_monitoring_enabled) === 1;
          this.external_transmission_active = newValue.external_transmission_active === true || Number(newValue.external_transmission_active) === 1;

          if(newValue.address){
            // Aplica a máscara do CEP quando carregado
            let cep = newValue.address.zip_code;
            if (cep && cep.length > 5) {
              cep = cep.substring(0, 5) + '-' + cep.substring(5, 8);
            }
            this.form.cep = cep;
            this.form.street = newValue.address.street;
            this.form.neighborhood = newValue.address.neighborhood;
            this.form.number = newValue.address.number;
            this.form.city = newValue.address.city;
            this.form.state = newValue.address.state;

          } else {
            this.form.cep = "";
            this.form.street = "";
            this.form.neighborhood = "";
            this.form.number = "";
            this.form.city = "";
            this.form.state = "";
          }
        }
      },
      immediate: true,
    }
  },
  methods: {
    ...mapActions([
      "setCurrentCamera"
    ]),
    handleCepInput(event) {
      // Remove todos os caracteres não numéricos
      let value = event.target.value.replace(/\D/g, '');
      
      // Aplica a máscara do CEP (00000-000)
      if (value.length > 5) {
        value = value.substring(0, 5) + '-' + value.substring(5, 8);
      }
      
      // Atualiza o valor no input
      event.target.value = value;
      this.form.cep = value;
      
      // Se o CEP tiver 9 caracteres (incluindo o hífen), busca o endereço
      if (value.length === 9) {
        this.fetchAddress();
      }
    },
    async fetchAddress() {
      this.$refs.cepFieldAlertUpdate.style.display = "none";
      if (this.form.cep.length !== 9) {
        return;
      }

      this.$refs.cepFieldUpdate.disabled = true;
      this.$refs.numberFieldUpdate.disabled = true;
      this.$refs.buttonUpdateUser.disabled = true;
      this.$refs.buttonUpdateUser.innerHTML = "Pesquisando Cep...";
      
      try {
        const response = await fetch(`https://viacep.com.br/ws/${this.form.cep.replace(/-/g, "")}/json/`);
        const data = await response.json();
        if (data.erro) {
          this.$refs.streetFieldUpdate.disabled = false;
          this.$refs.neighborhoodFieldUpdate.disabled = false;
          this.$refs.cityFieldUpdate.disabled = false;
          this.$refs.stateFieldUpdate.disabled = false;
          this.$refs.cepFieldUpdate.disabled = false;
          this.$refs.numberFieldUpdate.disabled = false;
          this.$refs.buttonUpdateUser.disabled = false;
          this.$refs.buttonUpdateUser.innerHTML = "Atualizar câmera";
          return;
        }
        this.form.street = data.logradouro || "";
        this.form.neighborhood = data.bairro || "";
        this.form.city = data.localidade || "";
        this.form.state = data.uf || "";

        this.$refs.streetFieldUpdate.disabled = true;
        this.$refs.neighborhoodFieldUpdate.disabled = true;
        this.$refs.cityFieldUpdate.disabled = true;
        this.$refs.stateFieldUpdate.disabled = true;

        this.$refs.cepFieldUpdate.disabled = false;
        this.$refs.numberFieldUpdate.disabled = false;
        this.$refs.buttonUpdateUser.disabled = false;
        this.$refs.buttonUpdateUser.innerHTML = "Atualizar câmera";
      } catch (error) {
        alert("Erro ao buscar o CEP. Tente novamente.");
        this.$refs.cepFieldUpdate.disabled = false;
        this.$refs.numberFieldUpdate.disabled = false;
        this.$refs.buttonUpdateUser.disabled = false;
        this.$refs.buttonUpdateUser.innerHTML = "Atualizar câmera";
      }
    },
    changeInformationInputs(element){
      this.$refs[element].style.borderColor = "#dedee4";
    },
    updateCameraMethod(){
      event.preventDefault();

      const update_record_option = document.getElementById("update_record_option").value;
      const update_active_option = document.getElementById("update_active_option").value;
      const storage_duration = this.$refs.storage_duration != undefined ? this.$refs.storage_duration.value : "0";

      if(update_active_option == ""){
        this.alertResponse("Por favor preencha o status da câmera", true);
        return;
      }
      
      if(update_record_option == ""){
        this.alertResponse("Por favor preencha a opção de gravação", true);
        return;
      }
      
      if(update_record_option == "1" && storage_duration == ""){
        this.alertResponse("Por favor preencha o tempo de duração de armazenamento", true);
        return;
      }

      if(this.form.cep == undefined || this.form.cep == ""){
        this.alertResponse("Por favor preencha o cep", true);
        return;
      }
      
      if(this.form.street == undefined || this.form.street == ""){
        this.alertResponse("Por favor preencha o endereço", true);
        return;
      }
      
      if(this.form.neighborhood == undefined || this.form.neighborhood == ""){
        this.alertResponse("Por favor preencha o bairro", true);
        return;
      }
      
      if(this.form.number == undefined || this.form.number == ""){
        this.alertResponse("Por favor preencha o número", true);
        return;
      }
      
      if(this.form.city == undefined || this.form.city == ""){
        this.alertResponse("Por favor preencha a cidade", true);
        return;
      }
      
      if(this.form.state == undefined || this.form.state == ""){
        this.alertResponse("Por favor preencha o estado", true);
        return;
      }

      const objCameraCreate= {
        "camera_id": this.getCurrentCamera.id,
        "active": update_active_option,
        "record": update_record_option,
        "ai_monitoring_enabled": this.ai_monitoring_enabled,
        "external_transmission_active": this.external_transmission_active,
        "storage_duration": storage_duration,
        "zip_code": this.form.cep,
        "street": this.form.street,
        "neighborhood": this.form.neighborhood,
        "number": this.form.number,
        "city": this.form.city,
        "state": this.form.state
      }
      
      const buttonUpdateUser = this.$refs.buttonUpdateUser;
      buttonUpdateUser.disabled = true;
      buttonUpdateUser.innerHTML = "Atualizando câmera...";
      const alertResponse = this.alertResponse;

      api.axios.post("/api/update/camera", objCameraCreate).catch(function(error){
        if(error.response.data != undefined){
          buttonUpdateUser.innerHTML = "Criar camera";
        }

        alertResponse(error.response.data, true);
      }).then(function(response){
        
        if(response != undefined && response.status == 200){
          buttonUpdateUser.innerHTML = "Camera atualizada com sucesso !";
          window.location.reload();
        } else {
          buttonUpdateUser.disabled = false;
          buttonUpdateUser.innerHTML = "Atualizar camera";
        }
      });
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessageUpdateCamera").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageUpdateCamera").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiUpdateCamera");
      if(elementAlert){
        if(error){
          
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 3000);
      }
    },
    openPricesModal() {
      // Abrir o modal de preços programaticamente para garantir funcionamento correto
      const pricesModal = new bootstrap.Modal(document.getElementById('PricesModal'));
      pricesModal.show();
    },
  }
};
</script>
